<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/obQ4hh/tc-custom/9780226230498.jpg?1736424826382" alt="This image is the cover for the book Difficult Reputations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Difficult Reputations
      </h1>
      <p class="bookDescription body article font2">
        <p>We take reputations for granted. Believing in the bad and the good natures of our notorious or illustrious forebears is part of our shared national heritage. Yet we are largely ignorant of how such reputations came to be, who was instrumental in creating them, and why. Even less have we considered how villains, just as much as heroes, have helped our society define its values.<br/> Presenting essays on America's most reviled traitor, its worst president, and its most controversial literary ingénue (Benedict Arnold, Warren G. Harding, and Lolita), among others, sociologist Gary Alan Fine analyzes negative, contested, and subcultural reputations. <i>Difficult Reputations</i> offers eight compelling historical case studies as well as a theoretical introduction situating the complex roles in culture and history that negative reputations play.<br/><br/> Arguing the need for understanding real conditions that lead to proposed interpretations, as well as how reputations are given meaning over time, this book marks an important contribution to the sociologies of culture and knowledge.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary Alan
      </h2>
      
      <p class="authorDescription body article"><B>Gary Fine</B> is a professor of sociology at Northwestern University. His many books include <I>Manufacturing Tales: Sex and Money in Contemporary Legends</I> and <I>With the Boys: Little League Baseball and Preadolescent Culture</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?646d9b46